import React from "react";
import TableRow from "./TableRow.jsx";

const TableBody = (props) => {
    const { data, editDate, deleteDate } = props;
    const { cuentaSeleccionada, permisos, modalidadDistribucionLimiteIdEncuentaSeleccionada, tarjetasFiltradas, solicitudId } = data;
    let newRequestCardAccountRowTableNodes = null;

    const crearFilaTarjeta = (tarjeta, index, solicitudId) => {
        return <TableRow solicitudId={solicitudId} tarjeta={tarjeta} permisos={permisos} valorCuenta={cuentaSeleccionada.Valor}
            key={"REQ_CREATE_CARD_" + index} permisos={permisos}
            modalidadDistribucionId={modalidadDistribucionLimiteIdEncuentaSeleccionada}
            editarTarjeta={editDate} eliminarTarjeta={deleteDate} />
    }

    if (data) {
        if (permisos.solicitudFunctionsAllowed.Confidencial == true) {
            newRequestCardAccountRowTableNodes = tarjetasFiltradas.map((t1, index) => {
                t1.Ordenamiento = index + 1;
                return crearFilaTarjeta(t1, index, solicitudId);
            });
        }
        else {
            newRequestCardAccountRowTableNodes = tarjetasFiltradas.filter((t1) => t1.EsConfidencial == false).map((t2, index) => {
                t2.Ordenamiento = index + 1;
                return crearFilaTarjeta(t2, index, solicitudId);
            });
        }
    }

    return (
        <tbody >
            {newRequestCardAccountRowTableNodes}
        </tbody>
    );
}

export default TableBody